
<!-- <nrk-window #quillWindow>
  <nrk-header><b>Mail</b></nrk-header>
  <nrk-content>
    <div>
      Recipient:
      <ngx-form-text [(ngModel)]="mailData.recipient" (ngModelChange)="onMailDataChanged(mailData)"></ngx-form-text>
    </div>
    <div>
      Subject:
      <ngx-form-text [(ngModel)]="mailData.subject" (ngModelChange)="onMailDataChanged(mailData)"></ngx-form-text>
    </div>
    <quill-editor [(ngModel)]="mailData.message" [modules]="quillModules" (onEditorCreated)="onEditorCreated($event)" (ngModelChange)="onMailDataChanged(mailData)"></quill-editor>
  </nrk-content>
</nrk-window> -->
<!-- <div>
  Das ist ein Test
</div> -->

<!-- <div>
  Recipient:
  <ngx-form-text [(value)]="mailData.recipient" (ngModelChange)="onMailDataChanged(mailData)"></ngx-form-text>
</div>
<div>
  Subject:
  <ngx-form-text [(value)]="mailData.subject" (ngModelChange)="onMailDataChanged(mailData)"></ngx-form-text>
</div>
<quill-editor [(ngModel)]="mailData.message" [modules]="quillModules" (onEditorCreated)="onEditorCreated($event)" (ngModelChange)="onMailDataChanged(mailData)"></quill-editor> -->

<div class="b-2">

  <div class="mb-4">
    <h4>List of Recipients</h4>
    <ngx-form-text [multiline]="1" [(value)]="mailData.recipient" placeholder=""></ngx-form-text>
  </div>

  <div class="mb-4">
    <h4>Subject</h4>
    <ngx-form-text [(value)]="mailData.subject" placeholder=""></ngx-form-text>
  </div>

  <div class="mb-4">
    <h4>Message</h4>
    <ngx-form-text [(value)]="actionHeaderText" placeholder=""></ngx-form-text>
  </div>

  <!-- <div class="mb-4">
    <h4>Action Points</h4>
    <quill-editor #quill [(ngModel)]="mailData.message" [modules]="quillModules" (onEditorCreated)="onEditorCreated($event)"></quill-editor>
  </div> -->

  <div class="action-table mb-4">
    <table>
      <tr>
        <th><button class="nrk-doc-button" (click)="addItem(-1)">+</button></th>
        <th>New</th>
        <th>Issue Date</th>
        <th>RSM</th>
        <th>Customer</th>
        <th>Doc #</th>
        <th>Description</th>
        <th></th>
        <th>Responsible</th>
        <th>Action Point</th>
        <th>Due Date</th>
        <th>✓</th>
        <th>Status</th>
        <th></th>
      </tr>
      <ng-container *ngFor="let item of actionPoints; index as idx">
        <ng-container *ngFor="let action of item.actions; index as aidx; first as first">
          <tr [style]="getRowStyle(item, action)">
            <td *ngIf="first" [attr.rowspan]="item.actions.length"><button class="nrk-doc-button" (click)="addItem(idx)">+</button></td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="text-align:center">{{isNew(item) ? '!' : ''}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length">{{item.issueDate | date : "yy-MM-dd"}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length">{{data.getOptionName(data.contactOptions, item.rsm)}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length"><ngx-doc-form-filter-select [(value)]="$any(item).customer" [options]="data.businessOptions" (valueChange)="setRsm(item, $event)"></ngx-doc-form-filter-select></td>
            <!-- <td *ngIf="first" [attr.rowspan]="item.actions.length"><ngx-doc-form-filter-select [(value)]="$any(item).doc" [options]="compilationOptions"></ngx-doc-form-filter-select></td> -->
            <td *ngIf="first" [attr.rowspan]="item.actions.length"> 
              <button class="nrk-button" [nbPopover]="docSelection" [nbPopoverTrigger]="'hover'">☰</button>
              {{$any(item).doc}}
              <ng-template #docSelection>
                <div class="p-4" (click)="$event.stopPropagation()">
                  <div>Business</div>
                  <ngx-doc-form-filter-select (valueChange)="setCompilationOptions($event)" [options]="data.businessOptions"></ngx-doc-form-filter-select>
                  <div class="mt-2">Document</div>
                  <ngx-doc-form-filter-select [(value)]="$any(item).doc" [options]="compilationOptions" (valueChange)="onDocSelected();"></ngx-doc-form-filter-select>
                </div>
              </ng-template>
            </td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length"><ngx-form-text [(value)]="item.description" [multiline]="1"></ngx-form-text></td>
            <td [style]="getActionStyle(item,action)">
              <div><button class="nrk-doc-button" (click)="addAction(idx, aidx)">+</button></div>
              <div><button class="nrk-doc-button" (click)="removeAction(idx, aidx)">-</button></div>
            </td>
            <td [style]="getActionStyle(item,action)">
              <ngx-doc-form-filter-select [(value)]="$any(action).responsible" [options]="data.nrkContactOptions"></ngx-doc-form-filter-select>
              <ngx-doc-form-texfield *ngIf="!item.responsible" [(value)]="$any(action).responsibleText"></ngx-doc-form-texfield>
            </td>
            <td [style]="getActionStyle(item,action)"><ngx-form-text [(value)]="action.actionPoint" [multiline]="1"></ngx-form-text></td>
            <td [style]="getActionStyle(item,action)"><ngx-doc-form-date [(value)]="$any(action).dueDate"></ngx-doc-form-date></td>
            <td [style]="getActionStyle(item,action)"><ngx-doc-form-checkbox [(value)]="action.completed" (valueChange)="onValueChange($event, item)"></ngx-doc-form-checkbox></td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length"><ngx-doc-form-dropdown [(value)]="item.status" [options]="actionPointOptions"></ngx-doc-form-dropdown></td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length"><button class="nrk-doc-button" (click)="removeItem(idx)">-</button></td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </div>

  <div class="flex items-center mb-4">
    <button class="btn btn-info btn-md" (click)="saveReportMailData()">Save Action Points</button>
    <button class="btn btn-info btn-md ml-4" (click)="sendMail()">Send Mail</button>
    <button class="btn btn-info btn-md ml-4" (click)="updateSorting()">Update Sorting</button>
  </div>

  <h5>Preview</h5>
  <div #preview>
    <div><b>Current Tasks</b></div>
    <table style="border-collapse: collapse;">
      <tr style="border: 1px solid black">
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">New</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Issue Date</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">RSM</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Customer</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Doc #</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Description</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Responsible</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Action Point</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Due Date</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">✓</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">Status</th>
      </tr>
      <ng-container *ngFor="let item of actionPoints; index as idx; last as isLast">
        <tr *ngIf="checkForCompletedHeader(item)">
          <td colspan="8" style="border: none; padding-top:0.5rem"><b>Last Week's Completed Tasks</b></td>
        </tr>
        <ng-container *ngFor="let action of item.actions; index as aidx; first as first">
          <tr [style]="getRowStyle(item, action)">
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="border: 1px solid black; padding: 0.5rem; text-align: center">{{isNew(item) ? '!' : ''}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="border: 1px solid black; padding: 0.5rem; text-align: center">{{item.issueDate | date : "yy-MM-dd"}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="border: 1px solid black; padding: 0.5rem;">{{data.getOptionName(data.contactOptions, item.rsm)}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="border: 1px solid black; padding: 0.5rem;">{{data.getOptionName(data.businessOptions, item.customer)}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="border: 1px solid black; padding: 0.5rem;">{{item.doc}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="border: 1px solid black; padding: 0.5rem;">{{item.description}}</td>
            <td [style]="getActionStyle(item, action, 'border: 1px solid black; padding: 0.5rem;')">{{data.getOptionName(data.contactOptions, action.responsible) || action.responsibleText}}</td>
            <td [style]="getActionStyle(item, action, 'border: 1px solid black; padding: 0.5rem;')">{{action.actionPoint}}</td>
            <td [style]="getActionStyle(item, action, 'border: 1px solid black; padding: 0.5rem; text-align: center')">{{action.dueDate | date : "yy-MM-dd"}}</td>
            <td [style]="getActionStyle(item, action, 'border: 1px solid black; padding: 0.5rem; text-align: center')">{{action.completed ? '✓' : ''}}</td>
            <td *ngIf="first" [attr.rowspan]="item.actions.length" style="border: 1px solid black; padding: 0.5rem;">{{data.getOptionName(actionPointOptions, item.status)}}</td>
          </tr>
        </ng-container>
      </ng-container>
    </table>

    <!-- <br>
    <h5>Last week IN in EUR</h5>
    <table style="margin-bottom:0.5rem">
      <tr>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">BU</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">EUR</th>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">NRVI</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekIN.nrvi | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">NRMM</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekIN.nrmm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">NRBM</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekIN.nrbm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">Energy Materials</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekIN.em | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
    </table>
    <br>
    <h5>Last week OR in EUR</h5>
    <table style="margin-bottom:0.5rem">
      <tr>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">BU</th>
        <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">EUR</th>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">NRVI</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekOR.nrvi | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">NRMM</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekOR.nrmm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">NRBM</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekOR.nrbm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
      <tr>
        <td style="border: 1px solid black; padding: 0.5rem">Energy Materials</td>
        <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{info.lastWeekOR.em | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
      </tr>
    </table>
    <br><br>
    Current stock level in EUR: {{info.currentStockLevelEUR | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}<br>
    Current stock level in USD: {{info.currentStockLevelUSD | currency : 'USD' : 'symbol' : '1.2-2' : 'de'}} -->
  </div>

</div>


